import { Box, Flex, xcss } from '@atlaskit/primitives';
import ContentLink from '@databases/content-link/ContentLink';
import { ContentReference } from '@databases/types/confluence';
import { DatabaseFieldType } from '@databases/types/database';
import { MultiValueChangeType, ValueChange } from '@databases/utils/database/changesets';
import React, { FunctionComponent, useCallback } from 'react';

import { FieldValueRemoveButton } from '../popover-edit-common';

import { ExtendedPageReference, Value } from './types';

const closeButtonStyling = xcss({
  paddingLeft: 'space.075',
});

interface PageLinkValueProps {
  resolvedValue: Value;
  resolvedValues: Value[];
  onChange: (value: Value[], change: ValueChange | null) => void;
  autoFocus: boolean | undefined;
  addDataSectionRef: React.MutableRefObject<HTMLDivElement | null>;
}

export const PageLinkValue: FunctionComponent<PageLinkValueProps> = ({
  resolvedValue,
  resolvedValues,
  onChange,
  autoFocus,
  addDataSectionRef,
}) => {
  const pageLinkValueIndex = resolvedValues.findIndex(
    (value) =>
      value &&
      'contentId' in value &&
      'contentId' in resolvedValue &&
      value.contentId === resolvedValue.contentId &&
      'ari' in value &&
      'ari' in resolvedValue &&
      value.ari === resolvedValue.ari &&
      value._id === resolvedValue._id
  );

  const onItemDelete = useCallback(() => {
    onChange(resolvedValues, {
      type: DatabaseFieldType.PAGE_LINK,
      delta: {
        type: MultiValueChangeType.REMOVE,
        index: pageLinkValueIndex,
      },
    });
    // focus the select input after each item removal
    addDataSectionRef.current?.getElementsByTagName('input')[0].focus();
  }, [addDataSectionRef, onChange, pageLinkValueIndex, resolvedValues]);

  return (
    <Flex testId={'page-link-value'} justifyContent={'start'} alignItems={'center'}>
      <ContentLink
        contentId={(resolvedValue as ExtendedPageReference | ContentReference).contentId}
        noFocus
      />
      <Box xcss={closeButtonStyling}>
        <FieldValueRemoveButton
          testId={'page-link-remove-button'}
          onItemDelete={onItemDelete}
          autoFocus={autoFocus}
        />
      </Box>
    </Flex>
  );
};
